// ══════════════════════════════════════════════════════════════════════════════════════════════
//  ESTE DISPOSITIVO (t398, 22-oct-2026 · el Busca en todos los dispositivos)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  Para decirle a quien busca «Sonando en 2 dispositivos» o «Atendido por Ana en el móvil», cada navegador y cada app se
//  pone un identificador propio (al azar, guardado en este navegador o en esta app) y lo dice al registrarse para los
//  avisos al móvil (push/registrarPush, hooks/useNotifications) y al hacer sonar un busca (components/busca/BuscaEntrante).
//  Así el servidor (routes/busca) sabe que el aviso al móvil y la pantalla abierta de un mismo teléfono son UNO. No dice
//  nada de quién es ni de dónde está: dos pestañas del mismo navegador son el mismo dispositivo.
//  Nunca lanza: sin almacenamiento, null (y el servidor cuenta como antes).
const CLAVE = 'biango-dispositivo'
const RE = /^[A-Za-z0-9_-]{8,64}$/

function nuevoId(w) {
  try {
    const c = w && w.crypto
    if (c && typeof c.randomUUID === 'function') return c.randomUUID().replace(/[^A-Za-z0-9]/g, '')
  } catch { }
  let s = ''
  for (let i = 0; i < 24; i++) s += Math.floor(Math.random() * 36).toString(36)
  return s
}

export function idDelDispositivo(entorno) {
  const w = entorno || (typeof window !== 'undefined' ? window : null)
  try {
    const ls = w && w.localStorage
    if (!ls) return null
    let v = ls.getItem(CLAVE)
    if (!v || !RE.test(v)) { v = nuevoId(w); ls.setItem(CLAVE, v) }
    return RE.test(v) ? v : null
  } catch { return null }
}

// Un móvil, una tableta o un ordenador: lo que se le dice a quien busca («en el móvil»). La app del móvil es un móvil (o
// una tableta, si su navegador lo dice).
export function tipoDeDispositivo(entorno) {
  const w = entorno || (typeof window !== 'undefined' ? window : null)
  const ua = String((w && w.navigator && w.navigator.userAgent) || '')
  if (/iPad|Tablet/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua))) return 'tableta'
  if (/Mobi|Android|iPhone|iPod/i.test(ua)) return 'movil'
  try { if (w && w.Capacitor && typeof w.Capacitor.isNativePlatform === 'function' && w.Capacitor.isNativePlatform()) return 'movil' } catch { }
  return 'ordenador'
}
